import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GradientLegend = _resolveComponent("GradientLegend")!

  return (_ctx.data)
    ? (_openBlock(), _createBlock(_component_GradientLegend, {
        key: 0,
        title: _ctx.data.title,
        colors: _ctx.data.colors,
        ticks: [_ctx.$t('message.low'), _ctx.$t('message.high')]
      }, null, 8, ["title", "colors", "ticks"]))
    : _createCommentVNode("", true)
}